/** 移动端 Footer 卡片（品牌区、底部导航共用） */
export const mobileCardClass =
  "overflow-hidden rounded-2xl border border-yoyo-border/70 bg-white shadow-sm";
